import { useContext } from 'react';
import { Tab, Tabs } from '@mui/material';

import Button from '../../../../../../common/general/Button';
import Icon from '../../../../../../common/general/Icon';
import { InvoiceContext } from '../../NewInvoiceContext';
import { DRAFT, tabsStyles } from '../CreateInvoiceConstants';
import { CustomTabPanel } from '../CreateInvoiceServices';

import { CreateInvoiceActionPanel } from './CreateInvoiceActionPanel/CreateInvoiceActionPanel';
import { InvoiceHistory } from './InvoiceHistory/InvoiceHistory';
import { PDFViewer } from './PDFViewer/PDFViewer';

export const ViewerSection = ({
  onCloseCreateInvoice,
  setCurrentTab,
  currentTab,
  savingType,
  invoiceNumber,
  PDFFile,
  invoiceCreated,
  generateFileName,
  selectedBillTo,
  selectedPayee,
  onSave,
  handlePrint,
  downloadFileAndLog,
  emailParams,
  setInvoiceNumber,
  generationInProgress,
  currentInvoiceType,
  pdfWasEdited,
  invoiceNumberForDisplay,
  billToList,
  invoiceWasReconciled
}) => {
  const { createInvoiceItems, editPDFMode } = useContext(InvoiceContext);
  return (
    <div className="pdf-preview-section">
      <div className="pdf-preview-header">
        <Button priority="low" size="h40" onClick={onCloseCreateInvoice}>
          <Icon>close</Icon>
        </Button>
        <Tabs
          value={currentTab}
          onChange={(event, newValue) => setCurrentTab(newValue)}
          sx={{
            width: '592px',
            marginTop: '8px',
            '.MuiTab-root': {
              width: '50%',
              maxWidth: '50%'
            }
          }}
          slotProps={{
            indicator: {
              sx: {
                backgroundColor: '#691E44'
              }
            }
          }}
        >
          <Tab label="Current Invoice" sx={tabsStyles} />
          <Tab label="Invoice History" sx={tabsStyles} disabled={invoiceNumber === DRAFT || !!savingType} />
        </Tabs>
      </div>
      <CustomTabPanel value={currentTab} index={0} className="tab-content">
        <PDFViewer file={editPDFMode && !pdfWasEdited ? createInvoiceItems.pdf : PDFFile} />
      </CustomTabPanel>
      <CustomTabPanel value={currentTab} index={1} className="tab-content-invoice-history">
        {invoiceNumber !== DRAFT && !savingType && (
          <InvoiceHistory
            invoiceNumber={invoiceNumber}
            invoiceNumberForDisplay={invoiceNumberForDisplay}
            emailModalBoxHeader={emailParams.emailModalBoxHeader}
            currentInvoiceType={currentInvoiceType}
            invoiceId={createInvoiceItems?.createdInvoiceDetails?.id}
            billToList={billToList}
          />
        )}
      </CustomTabPanel>
      {currentTab === 0 && (
        <CreateInvoiceActionPanel
          invoiceCreated={invoiceCreated}
          fileName={generateFileName(currentInvoiceType)}
          PDFFile={editPDFMode ? createInvoiceItems.pdf : PDFFile}
          selectedBillTo={selectedBillTo}
          selectedPayee={selectedPayee}
          onSave={onSave}
          savingType={savingType}
          handlePrint={handlePrint}
          downloadFile={downloadFileAndLog}
          emailParams={emailParams}
          generationInProgress={generationInProgress}
          setInvoiceNumber={setInvoiceNumber}
          currentInvoiceType={currentInvoiceType}
          pdfWasEdited={pdfWasEdited}
          invoiceWasReconciled={invoiceWasReconciled}
        />
      )}
    </div>
  );
};
